export default "__VITE_ASSET__BcImGxXB__"